/* CloudDream confirmation layer for Essential Cart Drawer's genuine remove action. */
(function (scope) {
  'use strict';

  var REMOVE_SELECTOR = '#essential-cart-drawer-portal [data-essential-cart-element="line-item-remove"]';
  var CONFIRMED_ATTRIBUTE = 'data-cd-remove-confirmed';
  var overlay = null;
  var pendingRemoveDescriptor = null;
  var returnFocusDescriptor = null;

  function getStrings() {
    return scope.CloudDreamCartRemoveStrings || {};
  }

  function createButton(className, text) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.textContent = text || '';
    return button;
  }

  function describeRemoveButton(removeButton) {
    var buttons = Array.prototype.slice.call(document.querySelectorAll(REMOVE_SELECTOR));
    return {
      button: removeButton,
      index: buttons.indexOf(removeButton),
      label: removeButton.getAttribute('aria-label'),
    };
  }

  function resolveRemoveButton(descriptor, root) {
    if (!descriptor) return null;
    if (descriptor.button && descriptor.button.isConnected) return descriptor.button;

    var queryRoot = root || document;
    var buttons = Array.prototype.slice.call(queryRoot.querySelectorAll(REMOVE_SELECTOR));
    var labelMatch = descriptor.label
      ? buttons.find(function (button) {
          return button.getAttribute('aria-label') === descriptor.label;
        })
      : null;

    return labelMatch || buttons[descriptor.index] || null;
  }

  function closeConfirmation(restoreFocus) {
    if (!overlay) return;

    var focusTarget = restoreFocus ? resolveRemoveButton(returnFocusDescriptor) : null;
    overlay.hidden = true;
    pendingRemoveDescriptor = null;

    if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    returnFocusDescriptor = null;
  }

  function performConfirmedRemoval(removeButton) {
    if (!removeButton || !removeButton.isConnected || typeof removeButton.click !== 'function') return false;
    if (typeof removeButton.hasAttribute === 'function' && removeButton.hasAttribute(CONFIRMED_ATTRIBUTE)) return false;

    removeButton.setAttribute(CONFIRMED_ATTRIBUTE, '');
    removeButton.click();
    removeButton.removeAttribute(CONFIRMED_ATTRIBUTE);
    return true;
  }

  function shouldBypassConfirmation(removeButton) {
    var groupedLine = removeButton && removeButton.closest
      ? removeButton.closest('[data-cd-grouped-quantity]')
      : null;
    var groupedQuantity = Number.parseInt(
      groupedLine && groupedLine.getAttribute('data-cd-grouped-quantity'),
      10,
    );
    return groupedQuantity > 1;
  }

  function handleDialogKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeConfirmation(true);
      return;
    }

    if (event.key !== 'Tab' || !overlay) return;

    var controls = Array.prototype.slice.call(overlay.querySelectorAll('button:not([disabled])'));
    if (!controls.length) return;

    var first = controls[0];
    var last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function createConfirmation(portal) {
    var strings = getStrings();
    var headingId = 'cd-cart-remove-title';
    var bodyId = 'cd-cart-remove-body';

    overlay = document.createElement('div');
    overlay.className = 'cd-cart-remove-overlay';
    overlay.hidden = true;

    var dialog = document.createElement('div');
    dialog.className = 'cd-cart-remove-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', headingId);
    dialog.setAttribute('aria-describedby', bodyId);

    var header = document.createElement('div');
    header.className = 'cd-cart-remove-header';

    var heading = document.createElement('h2');
    heading.id = headingId;
    heading.className = 'cd-cart-remove-title';
    heading.textContent = strings.title || '';

    var closeButton = createButton('cd-cart-remove-close', '×');
    closeButton.setAttribute('aria-label', strings.close || '');
    closeButton.addEventListener('click', function () {
      closeConfirmation(true);
    });

    var body = document.createElement('p');
    body.id = bodyId;
    body.className = 'cd-cart-remove-body';
    body.textContent = strings.body || '';

    var actions = document.createElement('div');
    actions.className = 'cd-cart-remove-actions';

    var cancelButton = createButton('cd-cart-remove-cancel', strings.cancel);
    cancelButton.addEventListener('click', function () {
      closeConfirmation(true);
    });

    var confirmButton = createButton('cd-cart-remove-confirm', strings.remove);
    confirmButton.addEventListener('click', function () {
      var removeButton = resolveRemoveButton(pendingRemoveDescriptor);
      closeConfirmation(false);
      performConfirmedRemoval(removeButton);
    });

    header.append(heading, closeButton);
    actions.append(cancelButton, confirmButton);
    dialog.append(header, body, actions);
    overlay.append(dialog);
    portal.append(overlay);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeConfirmation(true);
    });
    overlay.addEventListener('keydown', handleDialogKeydown);

    return { cancelButton: cancelButton };
  }

  function openConfirmation(removeButton) {
    var portal = document.getElementById('essential-cart-drawer-portal');
    if (!portal || !removeButton) return;

    var cancelButton;
    if (!overlay || !overlay.isConnected) cancelButton = createConfirmation(portal).cancelButton;
    else cancelButton = overlay.querySelector('.cd-cart-remove-cancel');

    pendingRemoveDescriptor = describeRemoveButton(removeButton);
    returnFocusDescriptor = pendingRemoveDescriptor;
    overlay.hidden = false;
    cancelButton.focus();
  }

  function handleDocumentClick(event) {
    var removeButton = event.target && event.target.closest ? event.target.closest(REMOVE_SELECTOR) : null;
    if (!removeButton || removeButton.hasAttribute(CONFIRMED_ATTRIBUTE)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (shouldBypassConfirmation(removeButton)) {
      performConfirmedRemoval(removeButton);
      return;
    }
    openConfirmation(removeButton);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      performConfirmedRemoval: performConfirmedRemoval,
      resolveRemoveButton: resolveRemoveButton,
      shouldBypassConfirmation: shouldBypassConfirmation,
    };
  }

  if (typeof document !== 'undefined') document.addEventListener('click', handleDocumentClick, true);
})(typeof window !== 'undefined' ? window : globalThis);
